import { Component, Input, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

import * as CryptoJS from "crypto-js";
import * as moment from 'moment';
moment.locale('de');

@Component({
  selector: 'dashboard-termin-module',
  templateUrl: './termin-module.component.html',
  styleUrls: ['./termin-module.component.scss'],
})

export class TerminModuleComponent implements OnInit {
  @Input() mode: string = 'content';
  @Input() email: string;
  
  toolTip: string = '';

  dates: any = {
    start: null,
    end: null,
    days: [],
    selected: null,
  };
  weeks: any[] = [];
  
  startPoint: any = moment();
  todos: any = {}
  todo: any = {
    type: 'aufgabe',
    email: '',
    title: '',
    description: '',
    start: '10:00',
    end: '12:00',
  }
  constructor(
    private storage: Storage,
  ) { }

  ngOnInit() {
    this.getTodos();
    // let entry1 = {
    //   title: '1 Termin Title ...',
    //   description: 'Short description of this termin.',
    //   start: '10:00',
    //   end: '12:00',
    // };
    this.todos = {
      // '05.03.2022': [
      //   entry1, entry2
      // ],
    }

    this.drawCalendar();
  }

  async getTodos() {
    this.todos = await this.storage.get('chatTodos') || {};
    console.log(67, this.todos);
  }


  drawCalendar(initDate = null) {
    this.weeks = [];
    this.dates.days = [];
    this.dates.start = null;
    this.dates.end = null;

    if (!initDate) { initDate = moment(); }
    this.dates.start = moment(initDate).startOf('month');
    this.dates.start = this.dates.start.startOf('week');
    
    this.dates.end   = moment(initDate).endOf('month');
    this.dates.end   = this.dates.end.endOf('week');
    
    let i = 0;
    this.weeks = [];
    while (this.dates.start.format() <= this.dates.end.format()) {
      i++;
      if (i === 1)  this.weeks.push(1);
      if (i === 8)  this.weeks.push(2);
      if (i === 15) this.weeks.push(3);
      if (i === 22) this.weeks.push(4);
      if (i === 29) this.weeks.push(5);
      if (i === 36) this.weeks.push(6);
      if (i === 43) this.weeks.push(7);

      this.dates.days.push(moment(this.dates.start));
      this.dates.start.add(1, 'day');
    }
  }

  m(date: any = null, format) {
    if (!date) date = moment();
    return (date.format(format));
  }
}
